import { type Item } from '@/components/wrapped/ActionCard';

// ── Calls ────────────────────────────────────────────────────────────────────

export type CallItem = {
  id: number;
  title: string;
  when: string; // '10th May at 10:00'
  withName: string;
  from: string;
  status: 'upcoming' | 'past';
  // Absent = the summary hasn't been written up yet (pending state).
  summary?: string;
  linkedActions: Item[];
  uploads: string[];
};

const linkedAction = (
  id: number,
  title: string,
  done: boolean,
  callWhen: string,
): Item => ({
  id,
  title,
  who: 'OP',
  createdBy: 'Yasmin',
  assignedTo: 'Assigned to you',
  due: 'Due Sat 24th May · 16:00',
  linkedCall: { when: callWhen, withName: 'Yasmin', from: 'Yasmin' },
  files: [],
  kind: 'cam',
  done,
});

export const CALLS: CallItem[] = [
  {
    id: 1,
    title: 'Funding call',
    when: '10th May at 10:00',
    withName: 'Yasmin',
    from: 'Yasmin',
    status: 'upcoming',
    linkedActions: [
      linkedAction(101, 'Upload a copy of your ID', false, '10th May at 10:00'),
      linkedAction(
        102,
        'Upload 3 months of bank statements',
        true,
        '10th May at 10:00',
      ),
      linkedAction(103, 'Upload a GP letter', true, '10th May at 10:00'),
    ],
    uploads: [],
  },
  {
    id: 2,
    title: 'Care assessment',
    when: '7th May at 10:00',
    withName: 'Yasmin',
    from: 'Yasmin',
    status: 'past',
    summary:
      'We need three months of recent statements to complete the funding picture. Please upload these as a PDF. I’ve attached an example of what they should look like.',
    linkedActions: [
      linkedAction(201, 'Upload a copy of your ID', false, '7th May at 10:00'),
      linkedAction(
        202,
        'Upload 3 months of bank statements',
        true,
        '7th May at 10:00',
      ),
      linkedAction(203, 'Upload a GP letter', true, '7th May at 10:00'),
    ],
    uploads: ['monzo_may_3months.pdf', 'example_file.pdf'],
  },
  {
    id: 3,
    title: 'Initial call',
    when: '5th May at 10:00',
    withName: 'Yasmin',
    from: 'Yasmin',
    status: 'past',
    summary:
      'We talked through Mum’s current situation and what support is in place today. Next we’ll look at funding options and gather the documents needed for the assessment.',
    linkedActions: [
      linkedAction(301, 'Buy a pill box', true, '5th May at 10:00'),
    ],
    uploads: ['example_file.pdf'],
  },
];

// ── Docs ─────────────────────────────────────────────────────────────────────

export type DocItem = {
  id: number;
  name: string;
  uploading?: boolean;
};

export const DOCS: DocItem[] = [
  { id: 1, name: 'example_file.pdf' },
  { id: 2, name: 'example_file.pdf' },
];

// ── Forms ────────────────────────────────────────────────────────────────────

export type FormItem = {
  id: string;
  title: string;
  answered: number;
  total: number;
};

export const FORMS: FormItem[] = [
  { id: 'care-assessment', title: 'Care assessment', answered: 12, total: 16 },
  {
    id: 'attendance-allowance',
    title: 'Attendance allowance',
    answered: 12,
    total: 20,
  },
  { id: 'financial-status', title: 'Financial status', answered: 9, total: 16 },
];

// ── Tools ────────────────────────────────────────────────────────────────────

export type ToolItem = {
  id: string;
  title: string;
  description: string;
};

export const TOOLS: ToolItem[] = [
  {
    id: 'care-shortlist',
    title: 'Care shortlist',
    description:
      'Your care search shortlist will appear from your care expert here.',
  },
  {
    id: 'benefits-calculator',
    title: 'Benefits eligibility calculator',
    description: 'See how much you could be entitled to.',
  },
];
